var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartFillBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-heart",
    "data-name": "Icon awesome-heart",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.286,
    height: 16,
    viewBox: "0 0 18.286 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-heart-2",
    "data-name": "Icon awesome-heart",
    d: "M16.51,3.342a4.884,4.884,0,0,0-6.664.486l-.7.725-.7-.725a4.884,4.884,0,0,0-6.664-.486,5.128,5.128,0,0,0-.354,7.425L8.332,17.9a1.12,1.12,0,0,0,1.618,0l6.911-7.136a5.125,5.125,0,0,0-.35-7.425Z",
    transform: "translate(0.001 -2.248)",
    fill: "#4c96ce"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFillBlue);
export default __webpack_public_path__ + "static/media/heart-fillBlue.f956b65347fd40a20f9086320cef533b.svg";
export { ForwardRef as ReactComponent };